import { buildSurveyMetadataPayload, collectSurveyFingerprint, getOrCreateSurveyDeviceId } from './survey-device';

var star = 0;

const PATH_CHECK_EXPIRE_JIRA = '/check-expire';
const PATH_RATE_JIRA = '/rate';

function getNormalizedEnv(env) {
    if (env === 'uat') {
        return 'uat';
    }

    if (window.location.hostname.includes('uat') || window.location.hostname === 'localhost') {
        return 'uat';
    }

    return 'production';
}

function getJiraBaseUrl(env) {
    if (getNormalizedEnv(env) === 'uat') {
        return 'https://uat-helpdesk.vexere.net';
    }

    return 'https://helpdesk.vexere.com';
}

$(document).ready(function() {
    const urlParams = new URLSearchParams(window.location.search);
    const paramId = urlParams.get('id');
    const paramKey = urlParams.get('key');
    const paramToken = urlParams.get('token');
    const env = getNormalizedEnv(urlParams.get('env'));

    const staff = urlParams.get('staff');
    const datetime = urlParams.get('call-datetime');

    if (staff) {
        $('.staff').text(staff);
    } else {
        $('.call-info').addClass('d-none');
    }
    if (datetime) {
      const datetimeRegex = /^(\d{2}):(\d{2}) (\d{2})[\/-](\d{2})[\/-](\d{4})$/;
      if (datetimeRegex.test(datetime)) {
        $('.call-datetime').text(datetime);
      } else {
        const displayedDatetime = new Date(parseInt(datetime)).toLocaleString('vi-VN', {
          timeZone: 'Asia/Ho_Chi_Minh',
          hour: '2-digit',
          minute: '2-digit',
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour12: false,
        });
        $('.call-datetime').text(displayedDatetime);
      }
    }

    $('.star').on('click', function(e) {
        selectStar($(this).attr('data-value'));
    });

    $('.btn-send-feedback').on('click', function(e) {
        submitForm();
    });
    
    if (!paramId && !paramKey && !paramToken) {
        $('.not-found').removeClass('d-none');
        $('.feedback-container').addClass('d-none');
        return;
    }

    if (paramId) {
        checkIsExpire(paramId, paramToken, env);
    } else if (paramToken) {
        checkIsExpireJiraByToken(paramToken, env);
    } else if (paramKey) {
        checkIsExpireJiraByKey(paramKey, env);
    }
});

function selectRateFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const paramRate = urlParams.get('rate');

    if (paramRate) {
        selectStar(+paramRate);
    }
}

function checkIsExpire(id, token, env) {
    const queryParams = new URLSearchParams({
        env,
    });

    if (token) {
        queryParams.set('token', token);
    }

    $.ajax({
        url: `/api/check-expire/${id}?${queryParams.toString()}`,
        method: 'GET',
        dataType: 'json',
        success: function(response) {
            const { data } = response;
            if (data && !data.isExist) {
                $('.feedback-container').addClass('d-none');
                Swal.fire({
                    title: 'Thông báo',
                    text: 'Đã hết hạn đánh giá',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }

            selectRateFromUrl();
        },
        error: function(response) {
            $('.feedback-container').addClass('d-none');
            Swal.fire({
                title: 'Thông báo',
                text: 'Có lỗi xảy ra',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    });
}

function checkIsExpireJiraByKey(id, env) {
    $.ajax({
        url: `${getJiraBaseUrl(env) + PATH_CHECK_EXPIRE_JIRA}?issueKey=${id}`,
        method: 'GET',
        dataType: 'json',
        success: function(response) {
            if (response && !response.isExist) {
                $('.feedback-container').addClass('d-none');
                Swal.fire({
                    title: 'Thông báo',
                    text: 'Đã hết hạn đánh giá',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }

            selectRateFromUrl();
        },
        error: function(response) {
            $('.feedback-container').addClass('d-none');
            Swal.fire({
                title: 'Thông báo',
                text: 'Có lỗi xảy ra',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    });
}

function checkIsExpireJiraByToken(token, env) {
    $.ajax({
        url: `${getJiraBaseUrl(env) + PATH_CHECK_EXPIRE_JIRA}?token=${encodeURIComponent(token)}`,
        method: 'GET',
        dataType: 'json',
        success: function(response) {
            if (response && !response.isExist) {
                $('.feedback-container').addClass('d-none');
                Swal.fire({
                    title: 'Thông báo',
                    text: 'Đã hết hạn đánh giá',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }

            selectRateFromUrl();
        },
        error: function(response) {
            $('.feedback-container').addClass('d-none');
            Swal.fire({
                title: 'Thông báo',
                text: 'Có lỗi xảy ra',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    });
}

// eslint-disable-next-line no-unused-vars
function selectStar(rating) {
    star = +rating;
    $('.star').removeClass('active');
    for (let i = 0; i < star; i++) {
        const instance = $(`.star:nth-child(${  i + 1  })`);
        instance.addClass('active');
    }
}

// eslint-disable-next-line no-unused-vars
function submitForm() {
    const $btn = $('.btn-send-feedback');
    if ($btn.prop('disabled')) {
        return;
    }

    const des = $('textarea[name="description"]').val();
    if (!star) {
        $('.error').removeClass('d-none');
        return;
    } else {
        $('.error').addClass('d-none');
    }

    $btn.prop('disabled', true);

    const urlParams = new URLSearchParams(window.location.search);
    const paramId = urlParams.get('id');
    const paramKey = urlParams.get('key');
    const paramToken = urlParams.get('token');
    const env = getNormalizedEnv(urlParams.get('env'));
    if (paramId) {
        $.ajax({
            url: '/api/submit-feedback',
            method: 'PUT',
            data: {
                id: paramId,
                token: paramToken,
                env,
                review_score: star,
                review_note: des,
                review_date: new Date().getTime()
            },
            dataType: 'json',
            success: function(response) {
                Swal.fire({
                    title: 'Thành công',
                    text: 'Gửi phản hồi thành công',
                    icon: 'success',
                    confirmButtonText: 'OK'
                });
            },
            error: function (request, status, error) {
                const inform = request.responseJSON && request.responseJSON.error && request.responseJSON.error.code === 3100 ? 'Bạn đã gửi phản hồi rồi' : 'Gửi phản hồi thất bại';
                Swal.fire({
                    title: 'Thất bại',
                    text: inform,
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }
        });
    }
    else if (paramToken || paramKey) {
        const deviceId = getOrCreateSurveyDeviceId();
        const metadataPayload = buildSurveyMetadataPayload({
            deviceId,
            fingerprint: collectSurveyFingerprint(),
        });
        $.ajax({
            url: getJiraBaseUrl(env) + PATH_RATE_JIRA,
            method: 'POST',
            data: {
                token: paramToken,
                issueKey: paramKey,
                rate: star,
                comment: des,
                ...metadataPayload,
            },
            dataType: 'json',
            success: function(response) {
                Swal.fire({
                    title: 'Thành công',
                    text: 'Gửi phản hồi thành công',
                    icon: 'success',
                    confirmButtonText: 'OK'
                });
            },
            error: function (request, status, error) {
                const inform = request.responseJSON && request.responseJSON.code === 400 ? 'Bạn đã gửi phản hồi rồi' : 'Gửi phản hồi thất bại';
                Swal.fire({
                    title: 'Thất bại',
                    text: inform,
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }
        });
    }
    return false;
}
